import { Injectable } from '@angular/core';
import { SwUpdate, UpdateAvailableEvent} from '@angular/service-worker';
import { interval } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwUpdateService {
  private readonly REJECTED_VERSION_KEY = 'sw-rejected-version';
  private readonly CURRENT_VERSION_KEY = 'sw-current-version';

  constructor(private swUpdate: SwUpdate) {
    console.log('[SW] Servicio de actualización inicializado');

    if (swUpdate.isEnabled) {
      console.log('[SW] ServiceWorker está habilitado');

      // Verifica cada minuto si hay una nueva versión
      interval(60_000).subscribe(() => {
        console.log('[SW] Buscando actualizaciones...');
        this.swUpdate.checkForUpdate().then(hasUpdate => {
          console.log('[SW] Resultado de checkForUpdate:', hasUpdate);

          if (hasUpdate == undefined) {
            this.verificarVersionesLocales();
          }

        }).catch(err => {
          console.error('[SW] Error al verificar actualizaciones:', err);
        });
      });

      this.swUpdate.available.subscribe((event: UpdateAvailableEvent) => {
        console.log('⚠️ [SW] Nueva versión disponible:', event);

        const currentHash = event.current?.hash;
        const availableHash = event.available?.hash;

        // Guardamos las versiones en el localStorage
        localStorage.setItem(this.CURRENT_VERSION_KEY, currentHash || '');
        localStorage.setItem('sw-available-version', availableHash || '');

        const rejectedVersion = localStorage.getItem(this.REJECTED_VERSION_KEY);

        if (availableHash && availableHash === rejectedVersion) {
          console.log('⏸️ [SW] Versión ya rechazada, no se muestra alerta');
          return;
        }

        this.mostrarAlertaDeActualizacion(availableHash);
      });

      this.swUpdate.activated.subscribe(event => {
        console.log('✅ [SW] Versión actual activada:', event.current);
        console.log('⬅️ [SW] Versión anterior:', event.previous);
        // Limpiar versiones guardadas
        localStorage.removeItem(this.REJECTED_VERSION_KEY);
        localStorage.setItem(this.CURRENT_VERSION_KEY, event.current?.hash || '');
      });
    } else {
      console.warn('[SW] ServiceWorker no está habilitado en este entorno');
    }
  }

  private verificarVersionesLocales() {
    const current = localStorage.getItem(this.CURRENT_VERSION_KEY);
    const available = localStorage.getItem('sw-available-version');
    const rejected = localStorage.getItem(this.REJECTED_VERSION_KEY);

    if (available && rejected === available && current !== available) {
      console.log('🔁 [SW] Se detectó versión rechazada anterior, preguntando nuevamente...');
      this.mostrarAlertaDeActualizacion(available);
    }
  }

  private mostrarAlertaDeActualizacion(hash: string | null) {
    Swal.fire({
      title: '¡Nueva versión disponible!',
      text: 'Se ha detectado una nueva versión de la aplicación con mejoras, correcciones y posibles nuevas funcionalidades. ¿Deseas actualizar ahora para disfrutar de una mejor experiencia?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Actualizar',
      cancelButtonText: 'Más tarde'
    }).then(result => {
      if (result.isConfirmed) {
        console.log('🟢 [SW] Usuario aceptó actualizar');
        this.swUpdate.activateUpdate().then(() => {
          console.log('🔄 [SW] Aplicación recargada con la nueva versión');
          document.location.reload();
        });
      } else {
        console.log('🟡 [SW] Usuario decidió actualizar más tarde');
        if (hash) {
          localStorage.setItem(this.REJECTED_VERSION_KEY, hash);
        }
      }
    });
  }
}
